import { useCallback } from 'react';
import { KeyCodes } from '@fluentui/react/lib/Utilities';

export function useKeydownSelection<T extends HTMLElement>(
    callback: (e: React.KeyboardEvent<T>) => void,
    deps?: React.DependencyList
): (e: React.KeyboardEvent<T>) => void {
    const onKeyDown = useCallback(
        (e: React.KeyboardEvent<T>) => {
            if (e.which === KeyCodes.space || e.which === KeyCodes.enter) {
                e.preventDefault();
                e.stopPropagation();

                callback(e);
            }
        },
        [deps]
    );

    return onKeyDown;
}
